import { render, staticRenderFns } from "./WrongProcessFactory.vue?vue&type=template&id=9c8e8d0a&"
import script from "./WrongProcessFactory.vue?vue&type=script&lang=js&"
export * from "./WrongProcessFactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports